import { mapGetters } from 'vuex'

import format from '@/module/util/format'

export default {
	props: {
        patient: {
            type: Object,
            required: true
        },
		schedule: {
			type: Object,
			required: true
		}
	},

	computed: {
		...mapGetters('content', [
			'getContentKey'
		]),
		...mapGetters('provider', [
			'getPatientMessage'
		]),
		messages() {
			if (! this.schedule.message)
				return []
				
			return this.schedule.message.map((messageId) =>
				this.getPatientMessage(this.patient.id, messageId))
		}
	},

	methods: {
		...format
	}
}
